import React from "react"
import { useTranslation } from "react-i18next";


export const Label = ({value,onChange,required,labelText,type ,name})=>{
  const { t } = useTranslation();
  return(
<div className="relative w-full my-4">
    <input type={type} id={labelText} className="block px-2.5 pb-2.5 pt-4 w-full body-1 text-light-subtitle  dark:text-dark-subtitle bg-light-secondary  dark:bg-dark-secondary rounded-lg border border-back-darktertiary/50  dark:border-light-glassStrok1 appearance-none  focus:outline-none focus:ring-0 focus:border-light-blue peer" placeholder=" " 
    value={value}
    onChange={onChange}
    required={required}

    name={name}
    />
    <label for={labelText} class="absolute text-sm text-light-subtitle  dark:text-dark-subtitle duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-light-secondary dark:bg-dark-secondary  px-2 peer-focus:px-2 peer-focus:text-light-blue dark:peer-focus:text-dark-subtitle  peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:bg-light-secondary  peer-focus:dark:bg-dark-secondary peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1 body-1">{t(labelText)}</label>
</div>
    )
}
export const DLabel = ({value,onChange,required,labelText,type ,name})=>{
  const { t } = useTranslation();
  return(
<div className="relative w-full my-4">
    <input type={type} id={labelText} className="block px-2.5 pb-2.5 pt-4 w-full body-1 text-light-subtitle  bg-light-secondary   rounded-lg border border-back-darktertiary/50  appearance-none  focus:outline-none focus:ring-0 focus:border-light-blue peer" placeholder=" " 
    value={value}
    onChange={onChange}
    required={required}

    name={name}
    />
    <label for={labelText} class="absolute text-sm text-light-subtitle  duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-light-secondary   px-2 peer-focus:px-2 peer-focus:text-light-blue  peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:bg-light-secondary  peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1 body-1">{t(labelText)}</label>
</div>
    )
}


export const TextArea = ({value,onChange,required,labelText,name,type,row})=>{
  const { t } = useTranslation();
  return(
<div className="relative w-full my-4">
    <textarea type="text" id={labelText} className="block px-2.5 pb-2.5 pt-4 w-full body-1 text-n-2 bg-light-secondary dark:bg-dark-secondary rounded-lg border  border-n-1/50 appearance-none  focus:outline-none focus:ring-0 focus:border-light-blue peer" placeholder=" " 
    value={value}
    onChange={onChange}
    required={required}
    name={name}
    row={row}

    />
    <label for={labelText} className="absolute text-sm text-gray-500  duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-n-8  px-2 peer-focus:px-2 peer-focus:text-light-blue  peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-focus:bg-light-secondary peer-focus:dark:bg-dark-secondary peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:bg-n-8 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1 body-1">{t(labelText)}</label>
</div>
    )
}










